export const iconStyle = {
  width: '2rem',
  fill: 'rgba(255, 255, 255, 0.5)',
  stroke: 'rgba(255, 255, 255, 0.5)',
  strokeWidth: '0.7rem',
};
